<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <logo />
        <h2 class="brand-text text-primary ml-1">Amini Finance</h2>
      </b-link>
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            👋 به سامانه آموزشی امیر امینی خوش آمدید.
          </b-card-title>

          <div class="divider my-2"></div>

          <b-alert variant="info" show>
            <div class="alert-body">
              <p>
                <strong>توجه: </strong>
                <span
                  >درصورتی که از کاربران سابق آکادمی امیر امینی میباشید در اولین
                  ورود برای تنظیم مجدد رمز عبور از بخش فراموشی رمز عبور استفاده
                  نمایید.</span
                >
              </p>
            </div>
          </b-alert>

          <div class="divider my-2"></div>

          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <b-form-group label="موبایل یا ایمیل" label-for="login-userName">
                <validation-provider
                  #default="{ errors }"
                  name="userName"
                  rules="required|notArabic|mobileEmail"
                >
                  <b-form-input
                    autocomplete="on"
                    id="login-userName"
                    v-model.trim="userName"
                    :state="errors.length > 0 ? false : null"
                    name="login-userName"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required|min:6|notArabic"
                >
                  <label for="login-password">رمز عبور</label>

                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      autocomplete="on"
                      id="login-password"
                      v-model.trim="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div class="d-flex justify-content-between">
                <b-form-group>
                  <b-form-checkbox
                    id="remember-me"
                    v-model="rememberMe"
                    name="checkbox"
                  >
                    بخاطر سپردن
                  </b-form-checkbox>
                </b-form-group>
                <b-link :to="{ name: 'auth-forgot-password' }">
                  <small>فراموشی رمز عبور</small>
                </b-link>
              </div>
              <b-button
                type="submit"
                variant="gradient-success"
                block
                autofocus
                :disabled="invalid"
              >
                ورود
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>هنوز ثبت نام نکرده اید‌؟</span>
            <b-link :to="{ name: 'auth-register' }">
              <span>ثبت نام</span>
            </b-link>
          </b-card-text>
          <div class="divider my-2"></div>
          <div
            class="auth-footer-btn d-flex justify-content-around align-items-baseline"
          >
            <b-card-text class="text-center mt-2">
              <span class="mr-1">شماره پشتیبانی</span>
              <b-link href="tel:+989191952581">
                <span>09191952581</span>
              </b-link>
            </b-card-text>

            <b-button
              variant="gradient-danger"
              class="btn-icon"
              href="https://instagram.com/amini.finance"
            >
              <feather-icon icon="InstagramIcon" />
            </b-button>
          </div>
        </b-col>
      </b-col>
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login" />
        </div>
      </b-col>
    </b-row>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Logo from "@core/layouts/components/Logo.vue";
import {
  BAlert,
  BButton,
  BCardText,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BRow,
} from "bootstrap-vue";
import {
  mobileEmail,
  notArabic,
  required,
} from "@/@core/utils/validations/validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    Loader,
    BForm,
    BButton,
    BAlert,
    Logo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      rememberMe: false,
      password: "",
      userName: "",
      sideImg: require("@/assets/images/login.png"),
      loading: false,
      required,
      mobileEmail,
      notArabic,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (this.$store.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/login.png");
        return this.sideImg;
      }
      return this.sideImg;
    },
    device() {
      return this.$store.state.appConfig.device;
    },
  },
  watch: {
    userName(val) {
      this.userName = this.p2e(val).toLowerCase();
    },
    password(val) {
      this.password = this.p2e(val);
    },
  },
  created() {
    if (localStorage.getItem("login")) {
      const item = JSON.parse(localStorage.getItem("login"));
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem("login");
      } else {
        this.userName = item.value.username;
        this.password = item.value.password;
        this.rememberMe = true;
      }
    }
  },
  methods: {
    setWithExpiry(key, value, ttl) {
      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem(key, JSON.stringify(item));
    },
    async login() {
      this.$refs.loginForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          if (this.rememberMe) {
            this.setWithExpiry(
              "login",
              {
                username: this.userName,
                password: this.password,
              },
              259200000
            );
          }
          try {
            const { data } = await this.$http.post("/auth/login", {
              username: this.userName,
              password: this.password,
              device_name: this.device,
            });
            this.$http.defaults.headers.common["Authorization"] =
              await `${data.data.type} ${data.data.token}`;
            await localStorage.setItem(
              "userData",
              JSON.stringify(data.data.user)
            );
            await this.$store.dispatch("auth/setUserData", data.data.user);
            await localStorage.setItem(
              "token",
              JSON.stringify({ val: data.data.token, type: data.data.type })
            );
            const isAdmin =
              (await data.data.user.permissions.permissions.length) > 0;
            await this.$store.commit(
              "appConfig/UPDATE_NAV_MENU_HIDDEN",
              Object.keys(data.data.user).length == 0
            );
            if (!data.data.user.mobile_verified_at) {
              this.$store.dispatch("auth/setVisibleCheckUser", true);
              this.$store.dispatch("auth/setVerifyType", "mobile");
            }
            if (!data.data.user.email_verified_at) {
              this.$store.dispatch("auth/setVisibleCheckUser", true);
              this.$store.dispatch("auth/setVerifyType", "email");
            }
            this.loading = false;
            this.$router
              .replace(
                isAdmin
                  ? "/dashboard"
                  : data.data.user.has_penalties
                  ? "/profile/penalties"
                  : "/profile/road-map"
              )
              .then(() => {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: ` ${
                        data.data.user.first_name +
                        " " +
                        data.data.user.last_name
                      } خوش آمدید.`,
                      icon: "CoffeeIcon",
                      variant: "success",
                    },
                  },
                  { position: "bottom-right" }
                );
              });
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
